import React, { useEffect, useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  Autocomplete,
  Button,
  Card,
  FormHelperText,
  FormControl,
  TextField,
  Typography,
  Box,
} from "@mui/material";
import { Stack } from "@mui/system";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import * as yup from "yup";
import CircularProgress from "@mui/material/CircularProgress";
import Avatar from "@mui/material/Avatar";
import SnackBarUI from "../../common/SnackUI";
import { useNavigate } from "react-router-dom";
import { uplodImageAction } from "../../redux/toolkit/image/uploadImage";
import { DevTool } from "@hookform/devtools";
import { appCategoryAction } from "../../redux/toolkit/apps/categories";
import AppbarUI from "../../common/AppbarUI";
import BodyWapperUI from "../../common/BodyWapperUI";
import DrawerUI from "../../common/DrawerUI";
import { appStoreAction } from "../../redux/toolkit/apps/store";

const app_schema = yup
  .object()
  .shape({
    app_name: yup.string().required("App Name is required."),
    app_logo: yup.string().required("App logo is required."),
    currency_name: yup.string().required("Currency Name is required."),
    currency_logo: yup.string().required("Currency Logo is required."),
    exchange_rate: yup
      .number()
      .typeError("Currency Conversion rate must be a number.")
      .min(0, "Currency Conversion rate can not less than 0")
      .positive("Currency Conversion rate must be a positive number.")
      .required()
      .nullable(),
    postback_url: yup.string().required("Postback Url is required."),
    // test_postback: yup.string().required('Test Postback is required.'),
    // screenout_payout: yup
    //   .number()
    //   .typeError('Screenout payout is required.')
    //   .min(0, "ScreenOut payout can not below 0")
    //   .positive('Screenout Payout must be a positive number.')
    //   .required('Screenout Payout is required.'),
    user_commission: yup
      .number()
      .typeError("User Commission must be a number.")
      .required("User Commission must be a number")
      .min(0, "User Commission must be at least 0.") // Minimum value check
      .max(100, "User Commission cannot exceed 100."),
    // ipSurveyLimit: yup
    //   .number()
    //   .typeError('IP Survey Limit must be a number.')
    //   .required("IP Survey Limit must be a number"),
    // attemptedSurveyLimit: yup
    //   .number()
    //   .typeError('Attempted Survey Limit must be a number.')
    //   .required("Attempted Survey Limit must be a number"),
    // callBackIpSurveyLimit: yup
    //   .number()
    //   .typeError('callBackIp Survey Limit must be a number.')
    //   .required("callBackIp Survey Limit must be a number"),
    // callBackCompletedSurveyLimit: yup
    //   .number()
    //   .typeError('callBackCompleted Survey Limit must be a number.')
    //   .required("callBackCompleted Survey Limit must be a number"),
    // callBackAttemptedSurveyLimit: yup
    //   .number()
    //   .typeError('callBackAttempted Survey Limit must be a number.')
    //   .required("callBackAttempted Survey Limit must be a number"),
    appLink: yup
      .string()
      .typeError("App Link must be a string.")
      .required("App Link must be a string")
      .test(
        "is-not-number",
        "App Link must contain non-numeric characters.",
        (value) => isNaN(value) || /\D/.test(value) // Ensures it's not a pure number
      ),
    // callbackScreenoutSurveyLimit: yup
    //   .number().required('Call Back ScreenOut Survey Limit  is required.')
    //   .typeError('Call Back ScreenOut Survey Limit is always number'),

    // commission: yup
    //   .number()
    //   .typeError('Commission must be a number.')
    //   .required("Commission Is Required"),
  })
  .required();

export default function CreateApp() {
  const {
    register,
    control,
    setError,
    watch,
    handleSubmit,
    formState: { errors },
    reset,
    getValues,
    setValue,
  } = useForm({
    resolver: yupResolver(app_schema),
    defaultValues: {},
  });

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [category, setCategory] = useState([]);
  const [platform, setPlatform] = useState();
  const [appLogo, setAppLogo] = useState();
  const [currLogo, setCurrLogo] = useState();
  const [theme, setTheme] = useState();
  const [snakbar, setSnakbar] = useState(false);
  const [adsEnabled, setAdsEnabled] = useState(false);
  const appCategory = useSelector((state) => state.appCategory);
  const { status, data: appCategoryData, message, loading } = appCategory;

  const [loader, setLoader] = useState(false);

  const appStore = useSelector((state) => state.appStore);
  const { status: Status, data: Data, message: Msg, loading: Load } = appStore;

  useEffect(() => {
    dispatch(appCategoryAction());
  }, [dispatch]);

  const categoryArr = appCategoryData;

  const platformArr = ["Android", "IOS", "Web"];

  const handleAppSubmit = async (data) => {
    setLoader(true);
    const appStore = await dispatch(
      appStoreAction({
        ...data,
        categories: category,
        app_logo: appLogo,
        currency_logo: currLogo,
        platform: platform,
        app_color: theme,
        is_ads_enabled: adsEnabled,
      })
    );
    setSnakbar(true);
    setTimeout(() => {
      setLoader(false);
      navigate("/apps");
    }, 2000);
  };

  const handleIconUpload = async (e) => {
    const formData = new FormData();
    formData.set("file", e.target.files[0]);
    let uploadedImg = await dispatch(uplodImageAction(formData));
    const imgStr = uploadedImg?.payload?.data?.url;
    setAppLogo(imgStr);
    setValue("app_logo", imgStr, {
      shouldValidate: true,
      shouldDirty: true,
      shouldTouch: true,
    });
  };

  const handleIconUpload2 = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const img = new Image();
    img.src = URL.createObjectURL(file);
    img.onload = async () => {
      // if (img.width > 25 || img.height > 25) {
      //   alert("Image dimensions should not exceed 25x25 pixels.");
      //   return;
      // }
      const formData = new FormData();
      formData.set("file", file);
      let uploadedImg = await dispatch(uplodImageAction(formData));
      const imgStr = uploadedImg?.payload?.data?.url;
      setCurrLogo(imgStr);
      setValue("currency_logo", imgStr, {
        shouldValidate: true,
        shouldDirty: true,
        shouldTouch: true,
      });
    };
  };

  const handleSwitchChange = () => {
    setAdsEnabled((prev) => !prev);
  };

  const handleChange = async (e) => {
    setTheme(e.target.value);
    setValue("app_color", e.target.value, {
      shouldValidate: true,
      shouldDirty: true,
      shouldTouch: true,
    });
  };

  return (
    <>
      <AppbarUI />
      <DrawerUI />
      <BodyWapperUI>
        {!loader ? (
          <Card sx={{ p:{xs:2,sm:5 , md:5}, border: "1px solid #000" }}>
            <Typography variant="h5" fontWeight={600} sx={{ mb: 5 }}>
              Create App
            </Typography>
            <form onSubmit={handleSubmit(handleAppSubmit)}>
              <Stack spacing={3}>
                {/* Postback URL */}
                <Stack
                  direction={{ xs: "column", sm: "row" }}
                  spacing={2}
                  justifyContent="center"
                  alignItems="center"
                >
                  <Box sx={{ width: "100%" }}>
                    <TextField
                      {...register("postback_url")}
                      error={!!errors?.postback_url?.message}
                      helperText={errors?.postback_url?.message}
                      label="Post Back Url"
                      fullWidth
                    />
                    <Typography sx={{ my: 1, fontSize: 12, opacity: 0.7 }}>
                      Request method will be "POST".
                    </Typography>
                  </Box>
                </Stack>

                {/* App Name & Currency Name */}
                <Stack
                  direction={{ xs: "column", sm: "row" }}
                  spacing={2}
                  justifyContent="start"
                  alignItems="flex-start"
                >
                  <Stack sx={{ width: { xs: "100%", sm: "50%" } }}>
                    <TextField
                      label="App Name"
                      type="text"
                      {...register("app_name")}
                      error={!!errors?.app_name?.message}
                      helperText={errors?.app_name?.message}
                      fullWidth
                    />
                    <Typography sx={{ my: 1, fontSize: 12, opacity: 0.7 }}>
                      Please Mention The App Name
                    </Typography>
                  </Stack>

                  <Stack sx={{ width: { xs: "100%", sm: "50%" } }}>
                    <TextField
                      label="Currency Name"
                      {...register("currency_name")}
                      error={!!errors?.currency_name?.message}
                      helperText={errors?.currency_name?.message}
                      fullWidth
                    />
                    <Typography sx={{ my: 1, fontSize: 12, opacity: 0.7 }}>
                      Please mention the currency name that you are using in
                      your app. for eg: coins.
                    </Typography>
                  </Stack>
                </Stack>

                {/* Logos */}
                <Stack
                  direction={{ xs: "column", sm: "row" }}
                  spacing={2}
                  alignItems="flex-start"
                  sx={{ width: "100%" }}
                >
                  {/* App Logo */}
                  <Stack sx={{ width: { xs: "100%", sm: "50%" } }} spacing={1}>
                    <Stack direction="row" spacing={2} alignItems="center">
                      <TextField
                        inputProps={{ accept: "image/*" }}
                        InputLabelProps={{ shrink: true }}
                        label="App Logo"
                        type="file"
                        id="app_logo"
                        onChange={handleIconUpload}
                        error={!!errors?.app_logo}
                        helperText={errors?.app_logo?.message}
                        fullWidth
                      />
                      <Avatar
                        alt="App Logo"
                        src={appLogo}
                        sx={{ width: 56, height: 56 }}
                      />
                    </Stack>
                    <Typography sx={{ fontSize: 12, opacity: 0.7 }}>
                      Please Enter The App Logo
                    </Typography>
                  </Stack>

                  {/* Currency Logo */}
                  <Stack sx={{ width: { xs: "100%", sm: "50%" } }} spacing={1}>
                    <Stack direction="row" spacing={2} alignItems="center">
                      <TextField
                        inputProps={{ accept: "image/*" }}
                        InputLabelProps={{ shrink: true }}
                        label="Currency Logo"
                        type="file"
                        id="curr_logo"
                        onChange={handleIconUpload2}
                        error={!!errors?.currency_logo}
                        helperText={errors?.currency_logo?.message}
                        fullWidth
                      />
                      <Avatar
                        alt="Currency Logo"
                        src={currLogo}
                        sx={{ width: 56, height: 56 }}
                      />
                    </Stack>
                    <Typography sx={{ fontSize: 12, opacity: 0.7 }}>
                      Max size of the logo is 25x25 px.
                    </Typography>
                  </Stack>
                </Stack>

                {/* Conversion Rate & Rev Share */}
                <Stack
                  direction={{ xs: "column", sm: "row" }}
                  spacing={2}
                  justifyContent="center"
                  alignItems="flex-start"
                >
                  <Box sx={{ width: { xs: "100%", sm: "50%" } }}>
                    <TextField
                      label="Currency Conversion Rate"
                      {...register("exchange_rate")}
                      error={!!errors?.exchange_rate?.message}
                      helperText={errors?.exchange_rate?.message}
                      fullWidth
                    />
                    <Typography sx={{ my: 1, fontSize: 12, opacity: 0.7 }}>
                      Please enter the currency value equivalent to 1$ in your
                      app.
                    </Typography>
                  </Box>
                  <Box sx={{ width: { xs: "100%", sm: "50%" } }}>
                    <TextField
                      label="User’s Rev-Share"
                      {...register("user_commission")}
                      error={!!errors?.user_commission?.message}
                      helperText={errors?.user_commission?.message}
                      fullWidth
                    />
                    <Typography sx={{ my: 1, fontSize: 12, opacity: 0.7 }}>
                      User's rev share: This is the amount, you will be giving
                      to the users from your revenue.
                    </Typography>
                  </Box>
                </Stack>

                {/* App Link */}
                <Stack
                  direction={{ xs: "column", sm: "row" }}
                  spacing={2}
                  justifyContent="center"
                >
                  <Box sx={{ width: "100%" }}>
                    <TextField
                      label="App Link"
                      {...register("appLink")}
                      error={!!errors?.appLink?.message}
                      helperText={errors?.appLink?.message}
                      fullWidth
                    />
                  </Box>
                </Stack>

                {/* Submit Button */}
                <Stack direction="row" justifyContent="center">
                  <Button
                    variant="contained"
                    type="submit"
                    sx={{
                      paddingInline: "40px",
                      width: { xs: "100%", sm: "auto" },
                      // background:
                      //   "linear-gradient(177.64deg, #FFB100 10.65%, #FE299F 275.27%)",
                      background:"#000000",
                      '&:hover': {
                        background: "#000000",
                      },
                      textTransform: "none",
                      mb: 0,
                      mt: { xs: 2, sm: 4 },
                    }}
                  >
                    Create App
                  </Button>
                </Stack>
              </Stack>
            </form>
          </Card>
        ) : (
          <Box
            sx={{
              display: "flex",
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
            }}
          >
            <CircularProgress />
          </Box>
        )}

        {snakbar && (
          <SnackBarUI
            state={snakbar}
            setState={setSnakbar}
            status={Status}
            message={Msg}
          />
        )}
      </BodyWapperUI>
      <DevTool control={control} />
    </>
  );
}
